import { IComponentsById, IComponentType, ISceneComp, ITrackingTypes } from "../component-data-structure";
import { getFaceTrackingComponentIdsBySceneId } from "./face-tracking";

export const getAllModelIdsBySceneId = (sceneId: string, componentsById: IComponentsById): string[] => {
    const scene = componentsById[sceneId] as ISceneComp;
    if (scene.trackingType === ITrackingTypes.face) {
        return getFaceTrackingComponentIdsBySceneId(sceneId, componentsById).filter(id => componentsById[id].type === IComponentType.Model3d);
    }
    return scene.children.filter(id => componentsById[id].type === IComponentType.Model3d);
}